module.exports = __webpack_public_path__ + "img/mclogo.39536f1c.png";